import React from "react";
import DataTable from "react-data-table-component";

function camelCaseToDisplayable(text) {
  let result = text.replace(/([A-Z])/g, " $1");
  let final = result.charAt(0).toUpperCase() + result.slice(1);
  return final;
}

function XTable({ rows, columns = [], ...props }) {
  return (
    <DataTable
      noHeader
      pagination
      columns={[...columns].map((column) => {
        return {
          name: camelCaseToDisplayable(column),
          selector: column,
          sortable: true,
        };
      })}
      data={rows}
      {...props}
    />
  );
}

export default XTable;
